import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=818eee8a&"
import script from "./Repository.vue?vue&type=script&lang=ts&"
export * from "./Repository.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports